import { createStyles, keyframes } from '@mantine/core';

import { VectorMarketplaceIcon } from '~/domains/design-system/vectors/VectorMarketplaceIcon';
import LogoMarketplace from '~/domains/design-system/vectors/LogoMarketplace';
import dt from '~/testing';

type MarketplaceBadgeProps = {
  label: string;
};

const shineSweep = keyframes({
  '0%': { transform: 'translateX(-100%)' },
  '20%, 100%': { transform: 'translateX(100%)' },
});

const useStyles = createStyles((theme) => ({
  badge: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._8}px`,
    borderRadius: theme.radius.xl,
    overflow: 'hidden',
    ...theme.other.glass,
    color: theme.white,
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: `linear-gradient(115deg, transparent 30%, ${theme.fn.rgba(theme.white, 0.15)} 42%, ${theme.fn.rgba(theme.white, 0.6)} 50%, ${theme.fn.rgba(theme.white, 0.15)} 58%, transparent 70%)`,
      transform: 'translateX(-100%)',
      animation: `${shineSweep} 3.5s cubic-bezier(0.45, 0, 0.55, 1) infinite`,
      pointerEvents: 'none',
    },
    '@media (prefers-reduced-motion: reduce)': {
      '&::after': { animation: 'none' },
    },
  },
}));

function MarketplaceBadge({ label }: MarketplaceBadgeProps) {
  const { classes } = useStyles();
  return (
    <div
      role="img"
      aria-label={label}
      className={classes.badge}
      data-test-id={dt.designSystem.badges.marketplaceBadge}
    >
      <VectorMarketplaceIcon />
      <LogoMarketplace isMarkShown={false} />
    </div>
  );
}

export default MarketplaceBadge;
